__turbopack_context__.v({
  "logo": "Score-module-scss-module__w2igXq__logo",
  "rating": "Score-module-scss-module__w2igXq__rating",
});
